import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import './asset/css/colleague-discount.css'
import './asset/css/common.css'
import './asset/css/all.css'
import App from './app/App'
import reportWebVitals from './reportWebVitals'

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
)
reportWebVitals()
